import { AppointmentViewModel } from "./appointment";
export interface IAppointmentDates {
    date: string;
    appointments: AppointmentViewModel[];
}

export class AppointmentDatesViewModel implements IAppointmentDates {
    date: string;
    appointments: AppointmentViewModel[];

    get selectedAppointment(): number {
        var appointment = this.appointments.filter(a => a.isMemberOf)[0];
        return appointment ? appointment.id : 0;
    }

    get day(): string {
        const date = new Date(this.date).getDate().toString();
        return date.length === 1 ? `0${date}` : date;
    }

    get dayName(): string {
        const days = [
            'Sonntag',
            'Montag',
            'Dienstag',
            'Mittwoch',
            'Donnerstag',
            'Freitag',
            'Samstag',
        ];
        const dayOfWeek: string = days[new Date(this.date).getDay()];
        return `${dayOfWeek} ${this.day}.${this.month}.`;
    }

    get month(): string {
        const month = new Date(this.date).getMonth() + 1;
        const monthNumber = month.toString();
        return monthNumber.length === 1 ? `0${monthNumber}` : monthNumber;
    }

    constructor(dateAppointments: IAppointmentDates) {
        this.date = dateAppointments.date;
        this.appointments = dateAppointments.appointments.map(a => new AppointmentViewModel(a));
    }
}
